import React, { useEffect } from 'react';
import { injectIntl } from 'react-intl';

import ActionButton from '../builder/ActionButton';
import TimeBar from '../builder/TimeBar';
import { adaptHeightOnWidget, isNotEmpty } from '../../lib/ep';

const Wrapper = (props) => {
	const is_preview = (props.is_preview != undefined) ? props.is_preview : false;
	if(!is_preview) return props.children;

	return (
		<div
			class="main_contents_flex timed_question_container"
			style={{ width:'100%' }}
		>
			{props.children}
		</div>
	)
}

const TriviaQuestion = (props) => {
	const selectAnswer = (answer) => {
		if(props.answer_click != undefined) props.answer_click(answer);
	};

	const apply_autogrow = props?.apply_autogrow ?? true;

	useEffect(() => {
		if(apply_autogrow === false) return;

		setTimeout(() => {
			adaptHeightOnWidget();
		}, 200);
	}, []);

	const question = props?.question ?? false;
	if(!question) return null;

	const answers = props?.answers ?? [];

	const time_counter_props = props?.time_counter_props ?? false;

	const total_questions = props?.total_questions ?? 1;
	let questions_arr = [];
	for(var i = 0; i < total_questions; i++) {
		questions_arr.push(i);
	}

	const is_preview = props?.is_preview ?? false;
	const question_img = question?.Question?.full_image ?? (question?.Question?.fullimage ?? false);

	return (
		<Wrapper is_preview={is_preview}>
			<article>
				<div class="question_text">
					{(question_img !== false) && (
						<div class="this_image">
							<img src={question_img} width="100%" alt="" />
						</div>
					)}

					{(question_img === false) && (
						<div class="this_text">
							{(isNotEmpty(question.Question, 'question')) && (
								<p dangerouslySetInnerHTML={{ __html:question.Question.question}} />
							)}
						</div>
					)}

					{(time_counter_props !== false) ? (
						<TimeBar
							{...time_counter_props}
							color={false}
						/>
					) : (
						<div class="countdown_bar gui_time_countdown width_100">
							<div class="bar" style={{ width:'100%' }} />
						</div>
					)}
				</div>

				<div class="answers_in_question">
					{answers.map((answer, i) => {
						return (
							<div key={`answer_${question.Question.id}_${i}`} class="flex_button answer_button">
								<ActionButton
									_fullclass="r"
									onClick={() => selectAnswer(answer)}
									autotranslate={false}
								>{answer.answer}</ActionButton>
							</div>
						)
					})}
				</div>
			</article>
		</Wrapper>
	)
};

export default injectIntl(TriviaQuestion);